





























































































import { AddressBridge, CurrentLocationText } from '@/views/address/bridge'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'
import { navigateTo } from '@/router'

export default defineClassComponent(
  {
    components: {
      CurrentLocationText,
    },
  },
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 秒杀信息
      seckillInfo = computed(() => this.goodsData.value.seckillInfo)
      securityValue = computed(() =>
        this.goodsData.value.serviceSafeguard.reduce((p, c) => {
          if (p) {
            return `${p}·${c.name}`
          }
          return p + c.name
        }, ''),
      )

      show = ref(false)

      // 选中 SKU 的展示文本
      selectedSkuDisplayText = computed(() =>
        this.goodsData.value.selectedSku.skuSpecs
          .map(item => item.selected.value)
          .join('、'),
      )

      // 点击规格
      handleSpecClick = () => {
        this.goodsData.value.showSkuPicker({
          action: 'buy',
        })
      }

      // 点击送至
      handleSendClick = () => {
        AddressBridge.chooseAddress([this.goodsData.value.commodityId])
      }

      // 点击资质
      handleCertClick = () => {
        navigateTo('MartCert', {
          id: this.goodsData.value.merchantId,
        })
      }

      handleSafeguard = () => {
        this.show.value = true
      }
      // 点击店铺
      handleMartClick = () => {
        navigateTo('MartIndex', {
          id: this.goodsData.value.merchantId,
        })
      }
    },
)
